const GTM = process.env.REACT_APP_GTM_CONTAINER
const MATOMO = process.env.REACT_APP_MATOMO_CONTAINER

function parseProduct( product ) {
  return {                        //  adding a product to a shopping cart.
    'name'    : product.title,
    'id'      : `${product.article_nr}`,
    'price'   : product.price,
    'brand'   : product.brand,
    'category': product.category && product.category.title,
    'variant' : product.variant,
    'quantity': product.count
  }
}

class Track {

  static purchase( { order, products } ) {
    if ( !GTM && !MATOMO ) return
    console.log( "TRACK purchase", { order, products } )

    // google tracker
    if (GTM) {
      window.dataLayer && window.dataLayer.push( {
        'event'    : 'purchase',
        'ecommerce': {
          'purchase': {
            'actionField': {
              'id'         : order.id,                         // Transaction ID. Required for purchases and refunds.
              'affiliation': 'Online Store',
              'revenue'    : order.netto,                     // Total transaction value (incl. tax and shipping)
              'tax'        : '0',
              'shipping'   : '0',
            },
            'products'   : products.map( parseProduct )
          }
        }
      } );
    }

    // matomo tracker
    if (MATOMO) {
      // add products to cart (check if needed with cart update messages?)
      products.forEach(function(product) {
        window._paq && window._paq.push(['addEcommerceItem',
            product.map_id,
            product.title,
            [product.category],
            product.price,
            product.count
        ]);
      });

      // send submit info
      window._paq &&  window._paq.push(['trackEcommerceOrder',
          String(order.id),
          order.netto
      ]);
    }
  }

  static checkout( { products, step = 1, option = "" } ) {
    if ( !GTM ) return
    console.log( "TRACK checkout", { products } )

    // google tracking
    window.dataLayer && window.dataLayer.push( {
      'event'    : 'checkout',
      'ecommerce': {
        'checkout': {
          'actionField': { 'step': step, 'option': option },
          'products'   : products.map( parseProduct )
        }
      }
    } );

  }


  static viewDetails( { product, list } ) {
    if ( !GTM && !MATOMO ) return
    console.log( "TRACK viewDetails", { product } )

    // google tracking
    if (GTM) {
      window.dataLayer && window.dataLayer.push( {
        'event'    : 'viewDetail',
        'ecommerce': {
          'detail': {
            'actionField': { 'list': `${list ? list : ""}` },    // 'detail' actions have an optional list property.
            'products'   : [parseProduct( product )]
          }
        }
      } )
    }

    // matomo tracking
    if (MATOMO) {
      console.log(product);
      // create track msg
      window._paq.push(['setEcommerceView',
          product.map_id,
          product.title,
          product.category ,
          product.price
      ]);
      // push msg
      window._paq.push(['trackPageView']);
    }

  }

  static removeProduct( { product } ) {
    if ( !GTM && !MATOMO ) return
    console.log( "TRACK removeProduct", { product } )

    if (GTM) {
      window.dataLayer && window.dataLayer.push( {
        'event'    : 'removeFromCart',
        'ecommerce': {
          'currencyCode': 'EUR',
          'remove'      : {                                // 'add' actionFieldObject measures.
            'products': [parseProduct( product )]
          }
        }
      } );
    }

  }

  static addProduct( { product } , sum) {
    if ( !GTM && !MATOMO ) return
    // console.log( "TRACK addProduct", { product } )

    // google tracking
    if (GTM) {
      window.dataLayer && window.dataLayer.push( {
        'event'    : 'addToCart',
        'ecommerce': {
          'currencyCode': 'EUR',
          'add'         : {                                // 'add' actionFieldObject measures.
            'products': [{                        //  adding a product to a shopping cart.
              'name'    : product.title,
              'id'      : `${product.article_nr}`,
              'price'   : product.price,
              'brand'   : product.brand,
              'category': product.category && product.category.title,
              'variant' : product.variant,
              'quantity': product.count
            }]
          }
        }
      } );
    }

    // window.ga( 'gtm1.ec:addProduct', {               // Provide product details in a productFieldObject.
    //   'id':         'P12345',                   // Product ID (string).
    //   'name':       'Android Warhol T-Shirt', // Product name (string).
    //   'category':   'Apparel',            // Product category (string).
    //   'brand':      'Google',                // Product brand (string).
    //   'variant':    'Black',               // Product variant (string).
    //   'position':   1,                    // Product position (number).
    //   'dimension1': 'Member'            // Custom dimension (string).
    // } );
    // window.ga( 'gtm1.ec:setAction', 'add' );
    // window.ga( 'gtm1.send', 'event', 'UX', 'click', 'add to cart' );
  }

}

window.track = Track
export default Track



// WEBPACK FOOTER //
// ./src/shop/track.js